import { Box } from '@mui/material'
import { useAtomValue } from 'jotai'
import * as React from 'react'

import PrivateSessionCreate from '../components/forms/PrivateSessionCreate'
import PrivateSessionSearch from '../components/forms/PrivateSessionSearch'
import { viewTypeAtom } from '../contexts/AtomUtil'
import { isAuthenticatedAtom } from '../domains/auth/AtomAuth'
import { isInstructorAtom } from '../domains/auth/AuthSelectors'

export default function Booking() {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)
  const isInstructor = useAtomValue(isInstructorAtom)
  const viewType = useAtomValue(viewTypeAtom)

  // 如果用户未登录或不是教练，只显示预约表单
  if (!isAuthenticated || !isInstructor) {
    return <PrivateSessionSearch />
  }

  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
        pb: '80px', // Add padding bottom to avoid content being covered by bottom navigation
      }}
    >
      {/* <CleanPrivateSessionForm /> */}
      {/* Content */}
      {viewType === 'instructor' ? <PrivateSessionCreate /> : <PrivateSessionSearch />}
    </Box>
  )
}
